/**
 * OC Demo Room Finder
 * 新 Section 专用；不依赖 demoroom-constant / us-google-map
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function firstLetter(name) {
    var n = String(name || '').trim();
    return n ? n.charAt(0).toUpperCase() : '?';
  }

  function splitCodes(value) {
    return String(value == null ? '' : value)
      .split(';')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  /** JSON 元字段可能返回 null / 字符串 / 对象三种形态，统一成可用结构 */
  function coerce(value, fallback) {
    var v = value;
    if (typeof v === 'string') {
      try {
        v = JSON.parse(v);
      } catch (e) {
        v = null;
      }
    }
    return v == null ? fallback : v;
  }

  function isEmptyObject(value) {
    return !value || (typeof value === 'object' && !Object.keys(value).length);
  }

  var DEFAULT_SERVICE_TYPE_ENUM = {
    S001: 'In-Person Visit',
    S002: 'On-Site Service',
    S003: 'Virtual Demo',
  };

  /** 标准 label → Figma pill 色（与 docs/demo-room/tag-pill-presets.cjs 一致） */
  var TAG_COLOR_DEFAULT = { bgColor: '#EDF9FF', textColor: '#158CC5' };
  var TAG_COLOR_TOP = { bgColor: 'rgba(248, 227, 192, 0.60)', textColor: '#B17007' };
  var TAG_LABEL_PRESETS = {
    '🏆 2025 TOP Host': TAG_COLOR_TOP,
    '2025 TOP Host': TAG_COLOR_TOP,
    '⭐ Top-rated Host': TAG_COLOR_DEFAULT,
    'Top-rated Host': TAG_COLOR_DEFAULT,
    '🔥 Popular Host': TAG_COLOR_DEFAULT,
    'Popular Host': TAG_COLOR_DEFAULT,
    '📈 Trending Host': TAG_COLOR_DEFAULT,
    'Trending Host': TAG_COLOR_DEFAULT,
    '🌱 Rising Star': TAG_COLOR_DEFAULT,
    'Rising Star': TAG_COLOR_DEFAULT,
    '📅 Available Host': TAG_COLOR_DEFAULT,
    'Available Host': TAG_COLOR_DEFAULT,
  };
  var TAG_CODE_LABELS = {
    T001: '⭐ Top-rated Host',
    T002: '🔥 Popular Host',
    T003: '📈 Trending Host',
    T004: '🌱 Rising Star',
    T005: '📅 Available Host',
    T006: '🏆 2025 TOP Host',
  };

  function trimTagLabel(raw) {
    return String(raw || '').trim();
  }

  function labelKeyForPreset(raw) {
    return String(raw || '')
      .replace(/^(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27BF])+\s*/g, '')
      .trim();
  }

  function presetForLabel(label) {
    var trimmed = trimTagLabel(label);
    if (!trimmed) return TAG_COLOR_DEFAULT;
    if (TAG_LABEL_PRESETS[trimmed]) return TAG_LABEL_PRESETS[trimmed];
    var key = labelKeyForPreset(trimmed);
    if (TAG_LABEL_PRESETS[key]) return TAG_LABEL_PRESETS[key];
    if (key === '2025 TOP Host' || /TOP Host/i.test(key)) return TAG_COLOR_TOP;
    return TAG_COLOR_DEFAULT;
  }

  /** Admin 只配 label 时补 Figma 色；已配 bgColor/textColor 的不覆盖；保留 emoji 图标 */
  function normalizeTagPill(tag) {
    if (!tag || typeof tag !== 'object') return null;
    var label = trimTagLabel(tag.label);
    if (!label) return null;
    var preset = presetForLabel(label);
    return {
      label: label,
      bgColor: tag.bgColor || preset.bgColor,
      textColor: tag.textColor || preset.textColor,
    };
  }

  function legacyCodeToPill(code) {
    var c = String(code || '').trim();
    if (!c) return null;
    var label = TAG_CODE_LABELS[c] || c;
    return normalizeTagPill({ label: label });
  }

  function normalizeData(raw) {
    var src = raw || {};
    var data = {
      markers: coerce(src.markers, []),
      machineList: coerce(src.machineList, []),
      machineCascaderList: coerce(src.machineCascaderList, []),
      serviceTypeEnum: coerce(src.serviceTypeEnum, {}),
      continentList: coerce(src.continentList, []),
    };

    if (isEmptyObject(data.serviceTypeEnum)) {
      data.serviceTypeEnum = DEFAULT_SERVICE_TYPE_ENUM;
    }

    var missing = Object.keys(data).filter(function (key) {
      var value = data[key];
      return Array.isArray(value) ? !value.length : isEmptyObject(value);
    });
    if (missing.length) {
      console.warn(
        '[oc-drf] 以下 Demo Room 元字段为空或未配置：' +
          missing.join(', ') +
          '（对应 shop.metafields.custom.demo_room_*，需 type=JSON）'
      );
    }
    return data;
  }

  /**
   * markers.tags：pill 对象数组；过渡期仍兼容 "T006;T001" 码串。
   */
  function buildPills(host) {
    var tags = host.tags;
    if (Array.isArray(tags)) {
      return tags
        .map(function (t) {
          return normalizeTagPill(t);
        })
        .filter(Boolean);
    }
    if (typeof tags === 'string' && tags.trim()) {
      return splitCodes(tags)
        .map(function (code) {
          return legacyCodeToPill(code);
        })
        .filter(Boolean);
    }
    return [];
  }

  function enrichMarkers(data) {
    var machineList = data.machineList || [];
    return (data.markers || []).map(function (item) {
      var miniSeriesArr = [];
      splitCodes(item.MachineCode).forEach(function (code) {
        var found = machineList.find(function (m) {
          return m.MachineCode === code;
        });
        if (found && found.MachineMiniSeries) miniSeriesArr.push(found.MachineMiniSeries);
      });
      return Object.assign({}, item, {
        MachineMiniSeries: Array.from(new Set(miniSeriesArr)),
      });
    });
  }

  function distanceMeters(a, b) {
    var toRad = Math.PI / 180;
    var lat1 = a.lat * toRad;
    var lat2 = b.lat * toRad;
    var dLat = (b.lat - a.lat) * toRad;
    var dLng = (b.lng - a.lng) * toRad;
    var x =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 6371000 * (2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)));
  }

  var productImageCache = {};

  function productHandleFromUrl(url) {
    var matched = String(url == null ? '' : url).match(/\/products\/([^/?#]+)/);
    return matched ? matched[1] : '';
  }

  function sizedImageUrl(url, size) {
    return String(url == null ? '' : url).replace(
      /(\.(?:png|jpe?g|webp|gif))(\?|$)/i,
      '_' + size + '$1$2'
    );
  }

  /**
   * 取 View Profile 指向的 Host Product 的主图前 3 张。
   * 走 Ajax API 而不是 Liquid：单模板内 all_products 最多只能访问 20 个产品，而 Host 有 90+ 个。
   * 失败或产品无图时返回空数组，由调用方回退到元字段里的 gallery。
   */
  function fetchProductImages(url) {
    var handle = productHandleFromUrl(url);
    if (!handle || typeof fetch !== 'function') return Promise.resolve([]);
    if (productImageCache[handle]) return Promise.resolve(productImageCache[handle]);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var endpoint = root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js';
    return fetch(endpoint, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (product) {
        var images = (product.images || []).filter(Boolean).slice(0, 3);
        productImageCache[handle] = images;
        return images;
      })
      .catch(function () {
        // 缓存空结果，避免同一 Host 每次 hover 都重复请求
        productImageCache[handle] = [];
        return [];
      });
  }

  function initFinder(root) {
    var data = normalizeData(window.OMT_DEMO_ROOM);
    var cfg = {
      apiKey: root.getAttribute('data-maps-key') || '',
      profileText: root.getAttribute('data-profile-text') || 'View Profile',
      locationPlaceholder: root.getAttribute('data-location-placeholder') || 'Your location',
      machinePlaceholder: root.getAttribute('data-machine-placeholder') || 'Machine',
    };

    var emptyHint = qs(root, '[data-oc-drf-empty]');
    if (emptyHint && !data.markers.length) {
      emptyHint.classList.add('is-visible');
    }

    var markersAll = enrichMarkers(data);
    var filtered = markersAll.slice();
    var selectedLocation = '';
    var selectedMachine = '';
    var selectedLocationLabel = '';
    var selectedMachineLabel = '';
    var selectedPoint = null;
    var map = null;
    var gMarkers = [];
    var activeHostId = null;
    var activeMarker = null;
    var hostCardOverlay = null;
    var hostCardHome = null;
    var isAdjustingPan = false;
    var HOST_CARD_PIN_GAP = 16;
    // 与老 us-google-map 一致：初始中心 + 有 pin 后统一 zoom 6
    var DEFAULT_MAP_CENTER = { lat: 30.2, lng: -116.5 };
    var DEFAULT_MAP_ZOOM = 4;
    var MARKERS_MAP_ZOOM = 6;
    var zoomRecenterTimer = null;
    // 未授权定位时：首屏只自动开一次官方 Showroom 卡
    var officialDefaultDone = false;

    var locateBox = qs(root, '[data-oc-drf-locate]');
    var locateBtn = qs(root, '[data-oc-drf-locate-enable]');
    var modal = qs(root, '[data-oc-drf-modal]');
    var modalClose = qsa(root, '[data-oc-drf-modal-close]');
    var searchBtn = qs(root, '[data-oc-drf-search]');
    var mapEl = qs(root, '[data-oc-drf-map]');
    var hostCard = qs(root, '[data-oc-drf-host-card]');
    var locationField = qs(root, '[data-oc-drf-location]');
    var machineField = qs(root, '[data-oc-drf-machine]');
    if (hostCard) hostCardHome = hostCard.parentElement;

    function restoreTriggerDisplays() {
      setTriggerValue(locationField, selectedLocationLabel, !selectedLocation);
      setTriggerValue(machineField, selectedMachineLabel, !selectedMachine);
    }

    function closeMenus() {
      qsa(root, '.oc-drf__field.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        el.classList.remove('is-filtering');
      });
      // 过滤输入后未点选时，回填已选文案（对齐 ElementUI filterable）
      restoreTriggerDisplays();
      renderLocationMenu('');
      renderMachineMenu('');
    }

    function getTriggerInput(field) {
      return qs(field, '[data-oc-drf-trigger-input]');
    }

    function setTriggerValue(field, text, isPlaceholder) {
      var input = getTriggerInput(field);
      if (!input) return;
      input.value = isPlaceholder ? '' : text || '';
      input.classList.toggle('is-placeholder', !!isPlaceholder);
    }

    function fuzzyMatch(haystack, needle) {
      if (!needle) return true;
      return String(haystack || '')
        .toLowerCase()
        .indexOf(String(needle).toLowerCase()) !== -1;
    }

    function renderLocationMenu(filterText) {
      var menu = qs(locationField, '[data-oc-drf-location-menu]');
      if (!menu) return;
      var query = String(filterText == null ? '' : filterText).trim();
      var list = (data.continentList || []).filter(function (item) {
        return fuzzyMatch(item.ContinentName, query);
      });

      var html =
        '<button type="button" class="oc-drf__menu-item" data-value="">' +
        escapeHtml(cfg.locationPlaceholder) +
        '</button>';

      if (!list.length) {
        html +=
          '<div class="oc-drf__menu-empty">No matching location</div>';
      } else {
        html += list
          .map(function (item) {
            var active = item.ContinentCode === selectedLocation ? ' is-active' : '';
            return (
              '<button type="button" class="oc-drf__menu-item' +
              active +
              '" data-value="' +
              escapeHtml(item.ContinentCode) +
              '">' +
              escapeHtml(item.ContinentName) +
              '</button>'
            );
          })
          .join('');
      }
      menu.innerHTML = html;
    }

    function flattenMachineOptions() {
      var rows = [];
      (data.machineCascaderList || []).forEach(function (parent, idx) {
        (parent.children || []).forEach(function (child) {
          rows.push({
            l1Index: idx,
            parentLabel: parent.label,
            value: child.value,
            label: child.label,
          });
        });
      });
      return rows;
    }

    function findMachineL1Index(machineValue) {
      if (!machineValue) return -1;
      var cols = data.machineCascaderList || [];
      for (var i = 0; i < cols.length; i++) {
        var children = cols[i].children || [];
        for (var j = 0; j < children.length; j++) {
          if (children[j].value === machineValue) return i;
        }
      }
      return -1;
    }

    function ensureMachineL2Col() {
      var cascader = qs(machineField, '[data-oc-drf-machine-menu]');
      if (!cascader) return null;
      var col = qs(machineField, '[data-oc-drf-machine-l2]');
      if (!col) {
        col = document.createElement('div');
        col.className = 'oc-drf__cascader-col';
        col.setAttribute('data-oc-drf-machine-l2', '');
        cascader.appendChild(col);
      }
      cascader.classList.add('has-l2');
      return col;
    }

    function renderMachineMenu(filterText) {
      var cascader = qs(machineField, '[data-oc-drf-machine-menu]');
      if (!cascader) return;
      var query = String(filterText == null ? '' : filterText).trim();

      // 有输入时对齐 ElementUI cascader filterable：展平为匹配的叶子项列表
      if (query) {
        machineField.classList.add('is-filtering');
        cascader.classList.remove('has-l2');
        var matched = flattenMachineOptions().filter(function (row) {
          return (
            fuzzyMatch(row.label, query) ||
            fuzzyMatch(row.parentLabel, query) ||
            fuzzyMatch(row.value, query)
          );
        });
        if (!matched.length) {
          cascader.innerHTML =
            '<div class="oc-drf__menu-empty">No matching machine</div>';
          return;
        }
        cascader.innerHTML =
          '<div class="oc-drf__cascader-flat">' +
          matched
            .map(function (row) {
              var active = row.value === selectedMachine ? ' is-active' : '';
              return (
                '<button type="button" class="oc-drf__menu-item' +
                active +
                '" data-machine-value="' +
                escapeHtml(row.value) +
                '" data-machine-label="' +
                escapeHtml(row.label) +
                '"><span class="oc-drf__menu-item-main">' +
                escapeHtml(row.label) +
                '</span><span class="oc-drf__menu-item-sub">' +
                escapeHtml(row.parentLabel) +
                '</span></button>'
              );
            })
            .join('') +
          '</div>';
        return;
      }

      machineField.classList.remove('is-filtering');
      cascader.classList.remove('has-l2');
      var cols = data.machineCascaderList || [];
      // 默认只渲染一级；点一级后再挂二级，避免右侧空面板
      cascader.innerHTML =
        '<div class="oc-drf__cascader-col" data-oc-drf-machine-l1>' +
        cols
          .map(function (item, idx) {
            return (
              '<button type="button" class="oc-drf__menu-item" data-l1-index="' +
              idx +
              '"><span>' +
              escapeHtml(item.label) +
              '</span><svg class="oc-drf__menu-arrow" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4.5L12.5 10L7.5 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
            );
          })
          .join('') +
        '</div>';
    }

    function renderMachineL2(index) {
      var parent = (data.machineCascaderList || [])[index];
      if (!parent) return;
      var col = ensureMachineL2Col();
      if (!col) return;

      qsa(machineField, '[data-l1-index]').forEach(function (el) {
        el.classList.toggle(
          'is-active',
          Number(el.getAttribute('data-l1-index')) === index
        );
      });

      var children = parent.children || [];
      col.innerHTML = children
        .map(function (child) {
          var active = child.value === selectedMachine ? ' is-active' : '';
          return (
            '<button type="button" class="oc-drf__menu-item' +
            active +
            '" data-machine-value="' +
            escapeHtml(child.value) +
            '" data-machine-label="' +
            escapeHtml(child.label) +
            '">' +
            escapeHtml(child.label) +
            '</button>'
          );
        })
        .join('');
    }

    /** 重开下拉时展开到已选路径，并滚到可见（对齐 ElementUI cascader） */
    function restoreMachineSelectionPath() {
      if (!selectedMachine) return;
      var l1Index = findMachineL1Index(selectedMachine);
      if (l1Index < 0) return;
      renderMachineL2(l1Index);

      var activeL1 = qs(machineField, '[data-l1-index="' + l1Index + '"]');
      var activeL2 = null;
      qsa(machineField, '[data-machine-value]').forEach(function (el) {
        if (el.getAttribute('data-machine-value') === selectedMachine) activeL2 = el;
      });
      if (activeL1 && activeL1.scrollIntoView) {
        activeL1.scrollIntoView({ block: 'nearest' });
      }
      if (activeL2 && activeL2.scrollIntoView) {
        activeL2.scrollIntoView({ block: 'nearest' });
      }
    }

    function openField(field) {
      if (!field) return;
      // 已展开时不再 toggle 关闭，避免点到 input 时 focus→open、click→close 连跳
      if (field.classList.contains('is-open')) {
        var openedInput = getTriggerInput(field);
        if (openedInput) openedInput.focus();
        return;
      }
      closeMenus();
      field.classList.add('is-open');

      // Machine 重开：自动展开并定位到已选项
      if (field === machineField) {
        renderMachineMenu('');
        restoreMachineSelectionPath();
      } else if (field === locationField) {
        renderLocationMenu('');
        if (selectedLocation) {
          qsa(locationField, '[data-value]').forEach(function (el) {
            if (
              el.getAttribute('data-value') === selectedLocation &&
              el.scrollIntoView
            ) {
              el.scrollIntoView({ block: 'nearest' });
            }
          });
        }
      }

      var input = getTriggerInput(field);
      if (!input) return;
      // 打开时选中已有文案，方便直接覆盖输入（对齐 ElementUI filterable）
      if (input.value) {
        try {
          input.select();
        } catch (e) {}
      }
      input.focus();
    }

    function bindDropdowns() {
      renderLocationMenu('');
      renderMachineMenu('');

      qsa(root, '[data-oc-drf-trigger]').forEach(function (trigger) {
        trigger.addEventListener('mousedown', function (e) {
          // 避免 mousedown 抢焦点导致 input blur 先关闭菜单
          if (e.target && e.target.tagName === 'INPUT') return;
          e.preventDefault();
        });
        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          var field = trigger.closest('.oc-drf__field');
          openField(field);
        });
      });

      var locationInput = getTriggerInput(locationField);
      if (locationInput) {
        locationInput.addEventListener('focus', function () {
          if (!locationField.classList.contains('is-open')) {
            openField(locationField);
          }
        });
        locationInput.addEventListener('input', function () {
          if (!locationField.classList.contains('is-open')) {
            locationField.classList.add('is-open');
          }
          renderLocationMenu(locationInput.value);
        });
        locationInput.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            closeMenus();
            locationInput.blur();
          } else if (e.key === 'Enter') {
            e.preventDefault();
            var first = qs(
              locationField,
              '[data-oc-drf-location-menu] .oc-drf__menu-item[data-value]:not([data-value=""])'
            );
            if (first) first.click();
          } else if (e.key === 'Backspace' || e.key === 'Delete') {
            // 清空输入时同步清掉已选，便于直接搜其他州
            if (locationInput.value.length <= 1) {
              selectedLocation = '';
              selectedLocationLabel = '';
            }
          }
        });
      }

      var machineInput = getTriggerInput(machineField);
      if (machineInput) {
        machineInput.addEventListener('focus', function () {
          if (!machineField.classList.contains('is-open')) {
            openField(machineField);
          }
        });
        machineInput.addEventListener('input', function () {
          if (!machineField.classList.contains('is-open')) {
            machineField.classList.add('is-open');
          }
          renderMachineMenu(machineInput.value);
        });
        machineInput.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            closeMenus();
            machineInput.blur();
          } else if (e.key === 'Enter') {
            e.preventDefault();
            var first = qs(machineField, '[data-machine-value]');
            if (first) first.click();
          } else if (e.key === 'Backspace' || e.key === 'Delete') {
            if (machineInput.value.length <= 1) {
              selectedMachine = '';
              selectedMachineLabel = '';
            }
          }
        });
      }

      locationField.addEventListener('click', function (e) {
        var item = e.target.closest('[data-value]');
        if (!item || !locationField.contains(item)) return;
        e.stopPropagation();
        selectedLocation = item.getAttribute('data-value') || '';
        selectedLocationLabel = selectedLocation ? item.textContent.trim() : '';
        setTriggerValue(locationField, selectedLocationLabel, !selectedLocation);
        closeMenus();
      });

      machineField.addEventListener('click', function (e) {
        var l1 = e.target.closest('[data-l1-index]');
        if (l1 && machineField.contains(l1)) {
          e.stopPropagation();
          qsa(machineField, '[data-l1-index]').forEach(function (el) {
            el.classList.remove('is-active');
          });
          l1.classList.add('is-active');
          renderMachineL2(Number(l1.getAttribute('data-l1-index')));
          return;
        }
        var l2 = e.target.closest('[data-machine-value]');
        if (l2 && machineField.contains(l2)) {
          e.stopPropagation();
          selectedMachine = l2.getAttribute('data-machine-value') || '';
          selectedMachineLabel = selectedMachine
            ? l2.getAttribute('data-machine-label') || selectedMachine
            : '';
          setTriggerValue(machineField, selectedMachineLabel, !selectedMachine);
          closeMenus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closeMenus();
        else if (!e.target.closest('.oc-drf__field')) closeMenus();
      });
    }

    function matchesFilters(item) {
      var hasLocation =
        selectedLocation && String(item.ContinentCode || '').indexOf(selectedLocation) !== -1;
      var mini = item.MachineMiniSeries || [];
      var hasMachine = selectedMachine && mini.indexOf(selectedMachine) !== -1;
      if (!selectedLocation && !selectedMachine) return true;
      if (selectedLocation && selectedMachine) return hasLocation && hasMachine;
      if (selectedLocation) return hasLocation;
      return hasMachine;
    }

    function applyFilter() {
      filtered = markersAll.filter(matchesFilters);
      if (selectedPoint) {
        filtered = filtered
          .map(function (item) {
            return Object.assign({}, item, {
              _distance: distanceMeters(item.Position, selectedPoint),
            });
          })
          .sort(function (a, b) {
            return a._distance - b._distance;
          });
      }
      renderMarkers();
    }

    function closeHostCard() {
      if (!hostCard) return;
      hostCard.classList.remove('is-open');
      hostCard.style.left = '';
      hostCard.style.top = '';
      hostCard.style.transform = '';
      hostCard.style.maxHeight = '';
      hostCard.style.overflowY = '';
      if (zoomRecenterTimer) {
        clearTimeout(zoomRecenterTimer);
        zoomRecenterTimer = null;
      }
      isAdjustingPan = false;
      activeHostId = null;
      activeMarker = null;
    }

    /** Name/Title 硬匹配官方 Showroom（现网 Name 常为短名，完整文案在 Title） */
    function findOfficialHost(list) {
      var hosts = list || [];
      var primary = null;
      var ontarioOfficial = null;
      var shortShowroom = null;
      var i;
      var name;
      var title;
      var blob;
      for (i = 0; i < hosts.length; i++) {
        name = String(hosts[i].Name || '');
        title = String(hosts[i].Title || '');
        blob = (name + ' ' + title).replace(/\s+/g, ' ').trim();
        if (/OMTech\s+Official\s+Showroom/i.test(blob)) {
          if (/Ontario/i.test(blob)) return hosts[i];
          if (!primary) primary = hosts[i];
        } else if (/Official\s+Showroom/i.test(blob) && /Ontario/i.test(blob)) {
          if (!ontarioOfficial) ontarioOfficial = hosts[i];
        } else if (
          /^OMTech\s+Showroom$/i.test(name.trim()) &&
          (/Ontario/i.test(title) || /Official/i.test(title))
        ) {
          // 现网：Name="OMTech Showroom", Title="OMTech Official Showroom in Ontario, …"
          if (!shortShowroom) shortShowroom = hosts[i];
        }
      }
      return primary || ontarioOfficial || shortShowroom || null;
    }

    function hostLatLngLiteral(host) {
      if (!host || !host.Position) return null;
      var pos = host.Position;
      var lat = Number(pos.lat != null ? pos.lat : pos.latitude);
      var lng = Number(pos.lng != null ? pos.lng : pos.longitude);
      if (isNaN(lat) || isNaN(lng)) return null;
      return { lat: lat, lng: lng };
    }

    function findMarkerForHost(host) {
      if (!host) return null;
      var i;
      for (i = 0; i < gMarkers.length; i++) {
        if (gMarkers[i].__host && gMarkers[i].__host.ID === host.ID) return gMarkers[i];
      }
      return null;
    }

    /** 未授权定位：首屏落到官方 pin 并展开 host 卡（只执行一次） */
    function openDefaultOfficialCard() {
      if (officialDefaultDone || selectedPoint || !map) return;
      var host = findOfficialHost(filtered.length ? filtered : markersAll);
      var center = hostLatLngLiteral(host);
      var marker = findMarkerForHost(host);
      if (!host || !center || !marker) {
        if (locateBox) locateBox.classList.add('is-visible');
        return;
      }
      officialDefaultDone = true;
      map.setCenter(center);
      map.setZoom(8);
      openHostCard(host, marker);
      if (locateBox) locateBox.classList.add('is-visible');
    }

    /**
     * Host 卡挂到 Maps floatPane（与 InfoWindow 同层）。
     * 勿用 InfoWindow：会裁切自定义卡，移动端看起来像旧小窗。
     * 勿挂在 mapEl 根节点：会被 .gm-style 盖住，全屏下尤其明显。
     */
    function ensureHostCardOverlay() {
      if (!map || !hostCard || !google.maps.OverlayView) return;
      if (hostCardOverlay) {
        mountHostCardToFloatPane();
        return;
      }

      hostCardOverlay = new google.maps.OverlayView();
      hostCardOverlay.onAdd = function () {
        mountHostCardToFloatPane();
      };
      hostCardOverlay.draw = function () {
        // 拖图/缩放时只跟随 pin，不再二次 pan（对齐老 InfoWindow 锚定）
        if (activeMarker && hostCard && hostCard.classList.contains('is-open')) {
          positionHostCard(activeMarker, 0, false);
        }
      };
      hostCardOverlay.onRemove = function () {
        // 全屏切换时 Maps 可能临时 detach overlay：若当前全屏的是 mapEl，卡片必须留在全屏树内
        if (!hostCard) return;
        var fs = document.fullscreenElement || document.webkitFullscreenElement || null;
        if (fs === mapEl) {
          if (hostCard.parentElement !== mapEl) mapEl.appendChild(hostCard);
        } else if (hostCardHome && hostCard.parentElement !== hostCardHome) {
          hostCardHome.appendChild(hostCard);
        }
        hostCard.classList.remove('is-map-overlay');
      };
      hostCardOverlay.setMap(map);
    }

    function mountHostCardToFloatPane() {
      if (!hostCardOverlay || !hostCard) return false;
      var panes = hostCardOverlay.getPanes && hostCardOverlay.getPanes();
      if (!panes || !panes.floatPane) return false;
      if (hostCard.parentElement !== panes.floatPane) {
        panes.floatPane.appendChild(hostCard);
      }
      hostCard.classList.add('is-map-overlay');
      return true;
    }

    function latLngToDivPixel(latLng) {
      ensureHostCardOverlay();
      if (!hostCardOverlay || !latLng) return null;
      var proj = hostCardOverlay.getProjection && hostCardOverlay.getProjection();
      if (!proj) return null;
      return proj.fromLatLngToDivPixel(latLng);
    }

    /**
     * 按地图可视高度限制 Host 卡，保证「卡居中」时整卡 + pin 同屏。
     * floatPane 上 percentage max-height 不可靠，用 mapEl 实测像素写入。
     */
    function applyHostCardMaxHeight() {
      if (!hostCard || !mapEl) return;
      var mapH = mapEl.clientHeight;
      if (!mapH) return;
      var pad = 16;
      var pinTail = 28;
      // 卡垂直居中时：卡自身边距 + pin 在卡下方的间隙与尖端留白
      var byPad = mapH - pad * 2;
      var byPin = mapH - HOST_CARD_PIN_GAP * 2 - pinTail * 2;
      var maxH = Math.max(180, Math.min(byPad, byPin));
      hostCard.style.maxHeight = maxH + 'px';
      hostCard.style.overflowY = 'auto';
    }

    /**
     * 将 Host 卡平移到地图视口中心：pin 随之落在卡下方。
     * 用 getBoundingClientRect 算屏幕位移（不受 DivPixel 原点偏移影响）；
     * 悬停/点击/缩放后都走这里，避免边缘修正仍被 overflow:hidden 裁切。
     *
     * panBy(dx,dy) 使屏幕内容移动 (-dx,-dy)；
     * 要让卡中心移到地图中心 → dx/dy = 卡中心 - 地图中心。
     */
    function ensureHostCardVisible() {
      if (isAdjustingPan || !map || !mapEl || !hostCard || !activeMarker) return;
      if (!hostCard.classList.contains('is-open')) return;

      applyHostCardMaxHeight();
      void hostCard.offsetHeight;

      var mapRect = mapEl.getBoundingClientRect();
      var cardRect = hostCard.getBoundingClientRect();
      if (!cardRect.width || !cardRect.height || !mapRect.width || !mapRect.height) return;

      var cardCX = (cardRect.left + cardRect.right) / 2;
      var cardCY = (cardRect.top + cardRect.bottom) / 2;
      var mapCX = (mapRect.left + mapRect.right) / 2;
      var mapCY = (mapRect.top + mapRect.bottom) / 2;
      var dx = cardCX - mapCX;
      var dy = cardCY - mapCY;

      // 忽略亚像素抖动，避免缩放后反复微调
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) return;

      isAdjustingPan = true;
      map.panBy(dx, dy);
      google.maps.event.addListenerOnce(map, 'idle', function () {
        isAdjustingPan = false;
        if (activeMarker) positionHostCard(activeMarker, 0, false);
      });
    }

    /**
     * 卡片锚在 pin 尖端正上方（translate -50% / -100%），禁止用视口 clamp 拽离 pin。
     * allowPan=true 时（打开/换 pin/缩放结束）把整卡平移到地图中心。
     */
    function positionHostCard(marker, attempt, allowPan) {
      if (!hostCard || !hostCard.classList.contains('is-open')) return;
      attempt = attempt || 0;
      if (!map || !marker) return;

      ensureHostCardOverlay();
      mountHostCardToFloatPane();
      applyHostCardMaxHeight();

      var pixel = latLngToDivPixel(marker.getPosition());
      if (!pixel) {
        if (attempt < 16) {
          setTimeout(function () {
            if (activeMarker === marker) positionHostCard(marker, attempt + 1, allowPan);
          }, 50);
        }
        return;
      }

      // 锚点 = pin 像素；卡片水平居中、整体在 pin 上方（与老 InfoWindow 一致）
      hostCard.style.left = pixel.x + 'px';
      hostCard.style.top = pixel.y + 'px';
      hostCard.style.transform =
        'translate(-50%, calc(-100% - ' + HOST_CARD_PIN_GAP + 'px))';

      if (allowPan) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (activeMarker === marker) ensureHostCardVisible();
          });
        });
      }
    }

    function openHostCard(host, marker) {
      if (!hostCard) return;
      activeHostId = host.ID;
      activeMarker = marker || null;

      var avatarEl = qs(hostCard, '[data-oc-drf-avatar]');
      var nameEl = qs(hostCard, '[data-oc-drf-host-name]');
      var verifiedEl = qs(hostCard, '[data-oc-drf-verified]');
      var addrEl = qs(hostCard, '[data-oc-drf-host-addr]');
      var bodyEl = qs(hostCard, '[data-oc-drf-host-body]');
      var tagsEl = qs(hostCard, '[data-oc-drf-host-tags]');
      var descEl = qs(hostCard, '[data-oc-drf-host-desc]');
      var galleryEl = qs(hostCard, '[data-oc-drf-gallery]');
      var profileEl = qs(hostCard, '[data-oc-drf-profile]');

      var avatarUrl = host.AvatarImgUrl || host.PositionImgUrl || '';
      if (avatarEl) {
        if (avatarUrl) {
          avatarEl.style.backgroundImage = 'url(' + avatarUrl + ')';
          avatarEl.textContent = '';
        } else {
          avatarEl.style.backgroundImage = '';
          avatarEl.textContent = firstLetter(host.Name);
        }
      }
      if (nameEl) nameEl.textContent = host.Name || '';
      // 现网数据无 verified 字段，Demo Room Host 均为官方认证，仅显式 false 时才隐藏
      if (verifiedEl) verifiedEl.style.display = host.verified === false ? 'none' : '';

      var addr =
        host.cityState ||
        (function () {
          var c = data.continentList.find(function (x) {
            return x.ContinentCode === host.ContinentCode;
          });
          return c ? c.ContinentName : '';
        })();
      if (addrEl) addrEl.textContent = addr;

      var pills = buildPills(host);
      if (tagsEl) {
        tagsEl.innerHTML = pills
          .map(function (p) {
            return (
              '<span class="oc-drf__pill" style="background:' +
              escapeHtml(p.bgColor) +
              ';color:' +
              escapeHtml(p.textColor) +
              '">' +
              escapeHtml(p.label) +
              '</span>'
            );
          })
          .join('');
      }

      var desc = String(host.description || host.MachineType || '').trim();
      if (descEl) {
        descEl.textContent = desc;
        descEl.classList.toggle('is-empty', !desc);
      }
      if (bodyEl) {
        bodyEl.classList.toggle('is-empty', !pills.length && !desc);
      }

      function renderGallery(urls) {
        if (!galleryEl) return;
        var list = (urls || []).filter(Boolean).slice(0, 3);
        galleryEl.classList.toggle('is-empty', !list.length);
        galleryEl.innerHTML = list
          .map(function (url) {
            return (
              '<div class="oc-drf__gallery-item"><img src="' +
              escapeHtml(url) +
              '" alt="" loading="lazy"></div>'
            );
          })
          .join('');
      }

      var galleryFallback = host.gallery || [];
      renderGallery(galleryFallback);

      if (profileEl) {
        profileEl.href = host.ScheduleYourTimeUrl || '#';
        profileEl.textContent = cfg.profileText;
      }

      hostCard.classList.add('is-open');
      ensureHostCardOverlay();
      applyHostCardMaxHeight();
      requestAnimationFrame(function () {
        positionHostCard(marker, 0, true);
      });

      // Host Product 主图优先；产品无图或请求失败时保持元字段 gallery 的兜底渲染
      fetchProductImages(host.ScheduleYourTimeUrl).then(function (images) {
        if (activeHostId !== host.ID) return;
        if (!images.length) return;
        renderGallery(
          images.map(function (url) {
            return sizedImageUrl(url, '400x');
          })
        );
        // 图片撑高后受 max-height 约束；等布局完成再 pan，避免底边被裁
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (activeHostId !== host.ID) return;
            positionHostCard(marker, 0, true);
          });
        });
      });
    }

    function clearMarkers() {
      gMarkers.forEach(function (m) {
        m.setMap(null);
      });
      gMarkers = [];
    }

    function renderMarkers() {
      if (!map) return;
      clearMarkers();
      closeHostCard();

      var bounds = new google.maps.LatLngBounds();
      var hasPoint = false;

      filtered.forEach(function (item) {
        if (!item.Position) return;
        // Position 可能是 {lat,lng} 或历史数据 {lng,lat}；统一成 LatLng
        var pos = item.Position;
        var latLng = new google.maps.LatLng(
          Number(pos.lat != null ? pos.lat : pos.latitude),
          Number(pos.lng != null ? pos.lng : pos.longitude)
        );
        if (isNaN(latLng.lat()) || isNaN(latLng.lng())) return;

        var marker = new google.maps.Marker({
          map: map,
          position: latLng,
          title: item.Name || '',
          // 默认 optimized canvas 在大量 pin 时 hover/click 经常丢事件
          optimized: false,
        });
        marker.__host = item;
        gMarkers.push(marker);
        bounds.extend(latLng);
        hasPoint = true;

        // 点击始终可开卡；hover 仅给真正有鼠标悬停的设备（避免触控板误判宽度）
        marker.addListener('click', function () {
          openHostCard(item, marker);
        });
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          marker.addListener('mouseover', function () {
            openHostCard(item, marker);
          });
        }
      });

      // 对齐老 us-google-map：有点时 setCenter(首点/选点) + zoom 6，不用 fitBounds
      // （新版地图容器更高，fitBounds 会显得更「远」）
      if (selectedPoint) {
        bounds.extend(selectedPoint);
        hasPoint = true;
        map.setCenter(selectedPoint);
        map.setZoom(MARKERS_MAP_ZOOM);
      } else if (hasPoint) {
        var official = findOfficialHost(filtered);
        var centerForMap =
          hostLatLngLiteral(official) || hostLatLngLiteral(filtered[0]) || filtered[0].Position;
        map.setCenter(centerForMap);
        map.setZoom(filtered.length === 1 || official ? 8 : MARKERS_MAP_ZOOM);
      } else {
        map.setCenter(DEFAULT_MAP_CENTER);
        map.setZoom(DEFAULT_MAP_ZOOM);
      }

      // renderMarkers 开头会 closeHostCard；官方默认卡须在画完 pin 后再开
      if (!selectedPoint) {
        openDefaultOfficialCard();
      }
    }

    function refreshMapLayout() {
      if (!map || !mapEl) return;
      var center = map.getCenter();
      var zoom = map.getZoom();
      google.maps.event.trigger(map, 'resize');
      if (center) map.setCenter(center);
      if (typeof zoom === 'number') map.setZoom(zoom);
      ensureHostCardOverlay();
      if (activeMarker && hostCard && hostCard.classList.contains('is-open')) {
        requestAnimationFrame(function () {
          positionHostCard(activeMarker, 0, true);
        });
      }
    }

    function bindMapChrome() {
      if (!map || !mapEl) return;
      ensureHostCardOverlay();

      map.addListener('idle', function () {
        if (activeMarker && !isAdjustingPan) positionHostCard(activeMarker, 0, false);
      });
      map.addListener('zoom_changed', function () {
        if (!activeMarker) return;
        // 缩放过程中先跟手贴 pin；结束后再把整卡重新居中，避免裁切加剧
        positionHostCard(activeMarker, 0, false);
        if (zoomRecenterTimer) clearTimeout(zoomRecenterTimer);
        zoomRecenterTimer = setTimeout(function () {
          zoomRecenterTimer = null;
          if (activeMarker && hostCard && hostCard.classList.contains('is-open')) {
            positionHostCard(activeMarker, 0, true);
          }
        }, 140);
      });
      map.addListener('center_changed', function () {
        if (activeMarker && !isAdjustingPan) positionHostCard(activeMarker, 0, false);
      });

      function onFullscreenChange() {
        // 全屏切换会重建 pane：先确保 overlay 还挂着，再 resize + 重定位
        if (hostCardOverlay) {
          try {
            hostCardOverlay.setMap(null);
            hostCardOverlay.setMap(map);
          } catch (e) {}
        } else {
          ensureHostCardOverlay();
        }
        refreshMapLayout();
        setTimeout(refreshMapLayout, 100);
        setTimeout(refreshMapLayout, 300);
      }
      document.addEventListener('fullscreenchange', onFullscreenChange);
      document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    }

    function initMap() {
      if (!mapEl || !window.google || !google.maps) return;
      if (map) return;
      map = new google.maps.Map(mapEl, {
        zoom: DEFAULT_MAP_ZOOM,
        center: DEFAULT_MAP_CENTER,
        mapTypeControl: true,
        fullscreenControl: true,
        streetViewControl: true,
        gestureHandling: 'greedy',
      });
      ensureHostCardOverlay();
      bindMapChrome();
      renderMarkers();
    }

    /** 同页老 us-google-map 依赖 callback=initMap；若 Maps 已被本模块先加载则需补调 */
    function bootLegacyUsGoogleMap() {
      var el = document.getElementById('map-ontolo');
      if (!el || el.getAttribute('data-oc-drf-legacy-booted') === '1') return;
      if (el.querySelector('.gm-style')) {
        el.setAttribute('data-oc-drf-legacy-booted', '1');
        return;
      }
      if (typeof window.initMap !== 'function') return;
      // 先打标，避免与 Maps callback / 轮询重入导致 double Map
      el.setAttribute('data-oc-drf-legacy-booted', '1');
      try {
        window.initMap();
      } catch (err) {
        el.removeAttribute('data-oc-drf-legacy-booted');
        console.warn('[oc-drf] legacy initMap failed', err);
      }
    }

    function scheduleLegacyBoot() {
      bootLegacyUsGoogleMap();
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        bootLegacyUsGoogleMap();
        var el = document.getElementById('map-ontolo');
        if (tries > 40 || (el && el.getAttribute('data-oc-drf-legacy-booted') === '1')) {
          clearInterval(timer);
        }
      }, 250);
    }

    function loadMaps() {
      function onReady() {
        initMap();
        scheduleLegacyBoot();
      }

      if (window.google && google.maps) {
        onReady();
        return;
      }

      // 已有 Maps script（老模块）时不重复注入，避免 callback 互相抢
      var existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if (existing) {
        var waited = 0;
        var waitTimer = setInterval(function () {
          waited += 1;
          if (window.google && google.maps) {
            clearInterval(waitTimer);
            onReady();
          } else if (waited > 200) {
            clearInterval(waitTimer);
            console.warn('[oc-drf] waiting for Google Maps timed out');
          }
        }, 50);
        return;
      }

      if (!cfg.apiKey) {
        console.warn('[oc-drf] missing Google Maps API key');
        return;
      }
      var cbName = '__ocDrfInitMap_' + root.id.replace(/[^a-zA-Z0-9_]/g, '');
      window[cbName] = function () {
        onReady();
      };
      var script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(cfg.apiKey) +
        '&callback=' +
        cbName +
        '&v=weekly&language=en-us&libraries=places';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    function tryGeolocation() {
      if (!navigator.geolocation) {
        if (locateBox) locateBox.classList.add('is-visible');
        return;
      }
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          selectedPoint = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          if (locateBox) locateBox.classList.remove('is-visible');
          if (modal) modal.classList.remove('is-open');
          // applyFilter → renderMarkers 会 closeHostCard，不再自动开最近 host
          applyFilter();
        },
        function () {
          if (locateBox) locateBox.classList.add('is-visible');
          // 失败：保留官方默认视图（若已开）；可打开引导弹窗说明如何开权限
          if (modal) modal.classList.add('is-open');
        },
        { timeout: 8000 }
      );
    }

    // 事件绑定
    bindDropdowns();

    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        applyFilter();
      });
    }

    if (locateBtn) {
      locateBtn.addEventListener('click', function () {
        tryGeolocation();
      });
    }

    modalClose.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (modal) modal.classList.remove('is-open');
      });
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.classList.remove('is-open');
      });
    }

    var closeBtn = qs(hostCard, '[data-oc-drf-host-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeHostCard();
      });
    }

    // 卡片在 floatPane 内时，阻止事件落到地图（否则点卡片会拖图/关卡）
    if (hostCard) {
      ['mousedown', 'touchstart', 'click', 'dblclick', 'wheel'].forEach(function (evt) {
        hostCard.addEventListener(evt, function (e) {
          e.stopPropagation();
        });
      });
    }

    // 未授权：展示 Enable 提示；首屏不自动要定位权限
    if (locateBox) locateBox.classList.add('is-visible');
    loadMaps();
  }

  ready(function () {
    qsa(document, '[data-oc-drf-root]').forEach(initFinder);
  });
})();
